module.exports = __webpack_public_path__ + "static/media/chevron-darkmode.0eefff93.svg";